var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"countdown__wrapper"},[_c('div',{staticClass:"countdown",class:{ warning: _vm.warning },attrs:{"id":_vm.sektorId}})])}
var staticRenderFns = []

export { render, staticRenderFns }